export default __webpack_public_path__ + "static/media/tree_icon_type_border_gray.645bb92e.svg";